import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from 'react-query';
import api from 'utils/api';
import folderKeys from './queryKeys';
function fetchFolders() {
  return _fetchFolders.apply(this, arguments);
}
function _fetchFolders() {
  _fetchFolders = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$api, items;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return api('get', '/api/query/folder', {
            fields: ['id', 'name', 'parent_id'],
            limit: 10000
          });
        case 2:
          _yield$api = _context.sent;
          items = _yield$api.items;
          return _context.abrupt("return", items);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchFolders.apply(this, arguments);
}
function useFetchFolders(queryOptions) {
  var queryKey = folderKeys.folders;
  var _useQuery = useQuery(queryKey, fetchFolders, _objectSpread(_objectSpread({}, queryOptions), {}, {
      staleTime: 5 * 60 * 1000
    })),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? [] : _useQuery$data,
    result = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread({
    items: data
  }, result);
}
export default useFetchFolders;